import React, { useState, useRef, useEffect } from 'react';
import { IoFilter } from 'react-icons/io5'; // assuming you're using IoFilter
import CMButton from '../../components/common/buttons/SimpleButton/CMButton';

export default function CSSortDropdown({ sortOpt, setSortOpt }) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const options = ['completed', 'pending', 'no-show'];

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      {/* Just use your existing CMButton here */}
      <CMButton
        icon={<IoFilter size={20} fontWeight={600} />}
        type="button"
        label="Filter"
        onClick={() => setOpen(!open)}
      />

      {/* Dropdown menu */}
      {open && (
        <div className="absolute top-full right-0 mt-2 bg-white rounded-md shadow-md inline-flex flex-col p-1 gap-1 w-[125px] z-50 transition-all duration-200">
          {options.map((option) => (
            <p
              key={option}
              className={`${
                sortOpt === option
                  ? 'text-white bg-accent hover:!bg-accent'
                  : ''
              } hover:bg-slate-50 baseText px-2 rounded-md py-1 cursor-pointer select-none`}
              onClick={() => {
                setSortOpt(option);
                setOpen(false); // close after choosing
              }}
            >
              {option.charAt(0).toUpperCase() + option.slice(1)}
            </p>
          ))}
        </div>
      )}
    </div>
  );
}
